import { Node, mergeAttributes } from "@tiptap/core";

/**
 * Atomic inline `{{…}}` variable token (the existing context/schema/data
 * substitution family). Rendered as a passive chip — editable/deletable but
 * carrying no capability grant. No React NodeView needed; a styled span is
 * enough (technical-design §6).
 */
export const VarTokenNode = Node.create({
  name: "varToken",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return { token: { default: "" } };
  },

  parseHTML() {
    return [{ tag: "span[data-var-token]" }];
  },

  renderHTML({ HTMLAttributes, node }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, {
        "data-var-token": "",
        class: "cc-var-token",
      }),
      node.attrs.token,
    ];
  },

  renderText({ node }) {
    return node.attrs.token as string;
  },
});
